<template>
  <div>
    <!-- 轮播图 -->
    <swiper title="生物安全" :bannerList="bannerList"></swiper>

    <!-- 项目背景 -->
    <section class="d-flex align-items-center pt-4 pb-4 text-line-height-1"  data-aos="fade-up">
      <div class="container">
        <main-title title="项目背景"></main-title>
        <retract-list :dataList="projectList"></retract-list>
      </div>
    </section>

    <!-- 项目介绍 -->
    <section class="d-flex align-items-center pt-4 pb-4 text-line-height-1"  data-aos="fade-up">
      <div class="container">
        <main-title title="项目介绍"></main-title>
        <retract-list :dataList="introduceList"></retract-list>
      </div>
    </section>

    <!-- 产品核心功能 -->
    <section class="d-flex align-items-center pt-4 pb-4 text-line-height-1"  data-aos="fade-up">
      <div class="container">
        <main-title title="产品核心功能"></main-title>
        <div class="indentation pb-4">
          <desc-list :dataList="coreList"></desc-list>
        </div>
        <picture>
          <source media="(max-width: 768px)" srcset="@/assets/img/md/mubang/mubang-1.png">
          <source media="(min-width: 768px)" srcset="@/assets/img/lg/mubang/mubang-1.png">
          <img src="@/assets/img/lg/mubang/mubang-1.png"  class="image-width-100 pt-4"/>
        </picture>
        <picture>
          <source media="(max-width: 768px)" srcset="@/assets/img/md/mubang/mubang-2.png">
          <source media="(min-width: 768px)" srcset="@/assets/img/lg/mubang/mubang-2.png">
          <img src="@/assets/img/lg/mubang/mubang-2.png"  class="image-width-100 pt-4"/>
        </picture>
      </div>
    </section>

  </div>
</template>

<script>
import Swiper from '@/components/Swiper.vue'
export default {
  name: 'MuBang',
  components: { Swiper,},
  props: {},
  data() {
    return {
      bannerList: [
        { src: require("@/assets/img/common/caseList/muBang/banner1.png") },
        { src: require("@/assets/img/common/caseList/muBang/banner2.png") },
        { src: require("@/assets/img/common/caseList/muBang/banner3.png") },
      ],
      // 项目背景
      projectList: [
        '畜牧业在农业产业中占有重要地位。然而，随着已成为全球危机并影响着人类健康和经济社会发展的新型冠状病毒(COVID-19)的爆发，人畜共患病及其防控措施引发了更多关注。制定养殖场机械化、智能化消杀技术规范，并加强对设备使用的技术指导，配套自动消杀监测和管理平台能有效地降低因防疫失效对养殖大环境防控的风险。',
        '智能花洒通过非视觉技术，有效监测洗澡人员头部、躯干在水中的沐浴时间，洗发液是否接到人员手中等关键数据，通过实时语音提醒辅助用户确保能够以符合猪场要求的时间、方式进行规范的洗澡， 系统对洗澡状态进行实时监测，包括人员洗澡状态、水温、用水量等，并将信息实时通知管理人员，该系统配套以多种身份识别方案进行联动操作，如数字ID识别或智能门禁等方式实现对洗澡人员的身份识别，洗澡违规提醒及指导，确保未按照要求进行洗消的人员得到及时纠正，实现洗浴消毒的流程自动化、数据化、人性化管理。',
      ],
      // 项目介绍
      introduceList: [
        '牧帮淋浴监控云平台是为牧业公司监控牧场工作人员淋浴的平台，拥有PC端和微信小程序端两个入口，主要包含企业、区域、场地、账号、员工、淋浴设备管理功能，和洗浴记录查看功能。'
      ],
      // 产品核心功能
      coreList: [
        {
          title: "数据统计：",
          titleDetail:
            "展示当前账号权限下的智能花洒和洗浴统计数据，并以卡片形式和环形图展示。",
        },
        {
          title: "基于SaaS的多租户系统：",
          titleDetail:
            "让多用户环境下使用同一套程序，且保证用户间数据隔离。",
        },
        {
          title: "设备管理: ",
          titleDetail:
            "录入花洒设备信息，当设备上线系统同步看的上线设备，便于监控各大场地设备使用情况。",
        },
        {
          title: "洗浴档案：",
          titleDetail:
            "展示详细洗浴档案并标注正常洗浴和异常洗浴，当异常洗浴发生，系统会以短信或者电话的形式通知当前场地的管理员，管理员也可以在小程序接受到这一通知。",
        }
      ]
    };
  },
  computed: {},
  watch: {},
  methods: {

  },
  created() {

  },
  mounted() {

  },
}
</script>
<style scoped>
</style>